import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import CountUp from "react-countup";
import {
  FaGraduationCap,
  FaUsers,
  FaSchool,
  FaAward,
} from "react-icons/fa";
import "./NiecceStatsSection.css";

const stats = [
  { icon: <FaAward />, value: 20, suffix: "+", label: "Years of Expertise", color: "#ee5951" },
  { icon: <FaGraduationCap />, value: 220, suffix: "+", label: "Batches Graduated", color: "rgb(0, 102, 205)" },
  { icon: <FaSchool />, value: 280, suffix: "+", label: "Schools Recruited Our Students", color: "#ee5951" },
  { icon: <FaUsers />, value: 8700, suffix: "+", label: "Students", color: "rgb(0, 102, 205)" },
];

const StatCard = ({ item, index }) => {
  // create an observer per card — will trigger counting only when visible
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.45, // adjust when you want the count to start
  });

  return (
    <motion.div
      ref={ref}
      className="stat-card"
      whileHover={{ scale: 1.04 }}
      initial={{ opacity: 0, y: 40 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, delay: index * 0.12 }}
    >
      <div className="icon-circle" style={{ color: item.color }}>
        {item.icon}
      </div>

      <h3 className="stat-value" style={{ color: item.color }}>
        {/* CountUp starts only when inView === true */}
        {inView ? (
          <CountUp end={item.value} duration={1.6} separator="," />
        ) : (
          0
        )}
        <span className="stat-suffix">{item.suffix}</span>
      </h3>

      <p className="stat-label">{item.label}</p>
    </motion.div>
  );
};

const NiecceStatsSection = () => {
  return (
    <section className="niecce-stats-section" aria-labelledby="niecce-stats-title">
      <div className="container">
        <motion.h2
          id="niecce-stats-title"
          className="stats-title"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          NIECCE at a Glance!
        </motion.h2>

        <div className="stats-grid">
          {stats.map((item, idx) => (
            <StatCard item={item} index={idx} key={idx} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default NiecceStatsSection;
